import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import ResultsCount from 'components/SA/Pagination/ResultsCount'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import AlgoliaConnector, { ConnectorProps as AlgoliaProps } from 'connectors/Algolia/Algolia'
import URLConnector, { ConnectorProps as URLProps } from '../connectors/Url'
import PaginationConnector, { ConnectorProps as PaginationProps } from '../connectors/Pagination'
import SelectHitsPerPage from '../components/SelectHitsPerPage'
import { updateBrowseUrl } from '../helpers/url'
import styles from './Browse.module.scss'

type BrowsePaginationProps = URLProps & AlgoliaProps & PaginationProps

const BrowsePagination: FC<BrowsePaginationProps> = (props) => {
  const { hitsPerPage, hitsTotal, currentPage, totalPages, getHref, category, hasPrints } = props
  const selectedCategory = hasPrints ? 'Prints' : category
  const categoryInResults = selectedCategory === 'Digital' ? 'Artworks' : selectedCategory

  return (
    <div className={styles.paginationContainer}>
      <Pagination
        current={currentPage + 1}
        total={totalPages}
        onClickLink={({ currentHref }) => {
          handleScrollToTop(() => {
            updateBrowseUrl(currentHref)
          })
        }}
        urlWithParam={getHref}
      />
      <ResultsCount
        hitsTotal={hitsTotal}
        hitsPerPage={hitsPerPage}
        category={categoryInResults}
        currentPage={currentPage}
      />
      {!!hitsTotal && <SelectHitsPerPage />}
    </div>
  )
}

export default AlgoliaConnector(URLConnector(PaginationConnector(BrowsePagination)))
